import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {DragDropModule} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-warning-confirm',
  templateUrl: './warning-confirm.component.html',
  styles: [`
    .info-branch {
      font-family: Roboto, "Helvetica Neue", sans-serif;
    }
  `]
})
export class WarningConfirmComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<WarningConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public message: string
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
  }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

}
